import React, { useState } from 'react';
import _ from 'lodash';
import { Box, Divider, Typography } from '@mui/material';
import MySkeleton from '../../../../components/Skeleton';
import { CardStyle } from '../../style-components/CardStyling';
import CheckableTickIcon from '../../../../components/CheckableTickIcon';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';

interface GettingStartedProps {
  loading: boolean;
  handleClickGettingStartedModal: any;
  setSelectedStep: any;
  handelOnClickPreviewArticleName: any;
  helpfulTips: any;
}

const GettingStartedCard: React.FC<GettingStartedProps> = ({
  loading,
  handleClickGettingStartedModal,
  handelOnClickPreviewArticleName,
  helpfulTips,
  setSelectedStep
}) => {
  const classes = CardStyle();
  const { forMobile } = useResponsiveScreenSwitch();

  // Track checked state for each item
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});

  const handleCheckChange = (id: string) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <Box className={classes.cardBox} minHeight={{ xs: 'auto', md: '240px' }}>
      <Box p={2}>
        <Typography variant="h5">{loading ? <MySkeleton width={150} /> : `Getting Started`}</Typography>
      </Box>
      <Divider />
      <Box p={2} display="flex" flexDirection="column" gap={1.6}>
        {helpfulTips.length === 0 ? (
          <Box pt={{ xs: 0, md: 5 }}>
            <Typography textAlign={'center'}>Nothing to see here.</Typography>
          </Box>
        ) : (
          helpfulTips.map((ele: any, index: number) => {
            const isChecked = checkedItems[ele._id] ?? false;

            return (
              <React.Fragment key={ele._id}>
                <Box
                  gap={1}
                  display="flex"
                  alignItems={'center'}
                  className="cursor-pointer"
                  onClick={() => {
                    handelOnClickPreviewArticleName(ele._id, ele.location);
                    handleCheckChange(ele._id);
                  }}
                >
                  <CheckableTickIcon
                    checked={ele.isRead}
                    // onChange={() => handleCheckChange(ele._id)}
                  />

                  <Typography noWrap variant="subtitle1" color="info.main">
                    {ele?.articleName}
                  </Typography>
                </Box>
              </React.Fragment>
            );
          })
        )}
      </Box>
    </Box>
  );
};

export default GettingStartedCard;
